enum Role {
  Owner = 'OWNER',
  User = 'USER',
}

export default Role;
